module.exports = __webpack_public_path__ + "img/logo_poise.c5499e98.png";